import { join, map, toLower } from 'ramda';
import { ScreenTemplate, TemplateType } from '@components-fabric/types';
import { findFirstValueDefined, selectNonEmptyValues } from '@dirootie-toolbox/objects';

export const sanitizeText = (text: string, regex: RegExp, char:string[1]) => toLower(text).replace(regex, char);
export const sanitizeTextForHeadings = (text: string) => sanitizeText(text, /[-_\/\s]/g, " ");
export const sanitizeTextForId = (text: string) => sanitizeText(text, /[-_\/\s]/g, "_").replaceAll("__","_");
export const sanitizeTextForPath = (text: string) => sanitizeText(text, /[-_\s]/g, "-").replaceAll("--","-");

export const toId = (segments: string[]) => join("_",map(sanitizeTextForId, segments));

export const getTemplate = (obj: ScreenTemplate):TemplateType =>
  findFirstValueDefined<TemplateType>(["tmp","section.tmp","id"],obj,"custom");

export const getScreenId = (obj: ScreenTemplate) => {
  const result = toId(selectNonEmptyValues(["section.sectionId","section.id","id"],obj))
  return result;
}

export const getRouteId = (obj: ScreenTemplate, context: any) => {
  const result =  context?.id?? toId(selectNonEmptyValues(["id","routeId","section.sectionId"],obj));
  return result;
}
